import styled from 'styled-components';

export const HeaderContainer = styled.div`
  height: 80px;
  position: sticky;
`;

export const Header = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: ${({ theme }) => theme.color.pickledBluewood};
  background-color: ${({ theme }) => theme.color.aquaSqueeze};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  padding: 0 25px;
  padding-left: ${({ isMenuOpen }) => (isMenuOpen ? 23 : 80)}px;
  transition: padding-left 0.3s;
  font-weight: 700;
`;

export const MemoryStatusContainer = styled.div`
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px;
  background-color: ${({ theme }) => theme.color.blackSqueeze};
`;

export const MemoryStatusMessage = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.color.baliHai};
`;

export const DocumentsList = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.dew};
  overflow: auto;
  height: calc(100svh - 80px);
`;
